import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import { container, fontStyle } from '../../../../style/mixins';

import {
  FONT_SIZE_7,
  FONT_WEIGHT_BOLD,
  GRAY_DARKER,
  MAIN_COLOR,
  GRAY_LIGHT_TWO,
} from '../../../../style/variables';

export const Container = styled.div`
  background-color: ${styles.colors.WHITE};
`;

export const Row = styled.div`
  &:first-child {
    border-bottom: 1px solid ${styles.colors.GRAY_LIGHT_2};
  }
`;

export const Content = styled.div`
  ${container}
  ${mixins.flexPosition({ align: 'stretch', justify: 'space-between' })}
`;

export const Title = styled.h1`
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_4,
    styles.fontWeights.SEMIBOLD
  )}
  margin: 0;
  padding: 25px 0;
`;

export const SubHeaderItem = styled.div`
  ${mixins.flexPosition({ direction: 'column' })}
  padding-right: 25px;

  padding-top: ${({ alignDeliveryPersonally }) => alignDeliveryPersonally && '8px'};

  & + & {
    border-left: 1px solid ${styles.colors.GRAY_LIGHT_2};
    padding-left: 25px;
  }
`;

export const SubHeaderTitle = styled.span`
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.SEMIBOLD
  )}
  line-height: 17px;
  margin-bottom: 2px;
`;

export const SubHeaderContent = styled.span`
  ${mixins.fontStyle(
    styles.colors.INFO_COLOR,
    styles.fontSizes.SIZE_6,
    styles.fontWeights.SEMIBOLD
  )}
  line-height: 19px;
`;

export const SubHeader = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  padding: 10px 0;
`;

export const LoaderContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.65);
  ${mixins.flexPosition({ align: 'center', justify: 'center' })}
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
`;

export const SwitchText = styled.td`
  padding: 5px;
  text-align: center;
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_BOLD)}
  color: ${({ isDeliveryPersonally }) => (isDeliveryPersonally ? MAIN_COLOR : GRAY_LIGHT_TWO)}
`;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/HeaderPage/style.js